import $ from 'jquery'

export default class StayConnected {
  constructor() {
    window.fnames = new Array();
    window.ftypes = new Array();
    
    fnames[0] = 'EMAIL';
    ftypes[0] = 'email';
    fnames[1] = 'FNAME';
    ftypes[1] = 'text';
    fnames[3] = 'ADDRESS';
    ftypes[3] = 'address';
    fnames[4] = 'PHONE';
    ftypes[4] = 'phone';
    fnames[2] = 'MMERGE2';
    ftypes[2] = 'zip';

    const $mcj = $.noConflict(true);

    // Initialize automatic scrolling to module
    window.onload = () => {
      setTimeout(() => {
        this.initScrollTo();
      }, 100);
    }
  }

  initScrollTo() {
    const urlHash = 'newsletter';

    // Scroll down to "Stay Connected" module if URL contains hash #newsletter
    if (window.location.hash === `#${urlHash}`) {
      const stayConnectedElement = document.querySelector('.stay-connected');

      if (stayConnectedElement) {
        const wpAdminBar = document.getElementById('wpadminbar');
        const windowHeight = window.innerHeight;
        const stayConnectedElementHeight = stayConnectedElement.offsetHeight;
        
        // Calculate scroll offset
        let scrollOffset = 0;
        
        if (stayConnectedElementHeight < windowHeight) {
          scrollOffset = (windowHeight - stayConnectedElementHeight) / 2;
        }

        // Adjust positioning when admin bar is present
        if (wpAdminBar) {
          scrollOffset -= wpAdminBar.offsetHeight;
        }

        // Scroll to element
        window.scrollTo(0, stayConnectedElement.offsetTop - scrollOffset);
      } else {
        console.warn(`URL contained hash #${urlHash}, but no Stay Connected module found`);
      }
    }
  }
}
